module.exports = __webpack_public_path__ + "static/img/day4.04cd8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day4.jpg
// module id = pTXD
// module chunks = 0